// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"am","flipped":"bm","mainContentCtaDefault":"cm","disabled":"dm","mainContentCtaWhite":"em"};